(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlideshow = (root = document) => {
      root.querySelectorAll("[data-mc-hero-slideshow]").forEach((slideshow) => {
        if (slideshow.dataset.ready === "true") return;
        slideshow.dataset.ready = "true";

        const slides = Array.from(slideshow.querySelectorAll("[data-mc-hero-slide]"));
        const dots = Array.from(slideshow.querySelectorAll("[data-mc-hero-dot]"));
        const prev = slideshow.querySelector("[data-mc-hero-prev]");
        const next = slideshow.querySelector("[data-mc-hero-next]");
        const autoplay = slideshow.dataset.autoplay === "true";
        const pauseOnHover = slideshow.dataset.pause === "true";
        const interval = Number(slideshow.dataset.interval) || 5000;
        let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
        let intervalId = null;
        let paused = false;

        const loadDeferredVideo = (video) => {
          if (!video.hasAttribute("data-mc-deferred-video") || video.dataset.loaded === "true") {
            return Promise.resolve();
          }
          if (video.dataset.loadScheduled === "true") return Promise.resolve();
          video.dataset.loadScheduled = "true";

          return new Promise((resolve) => {
            const load = () => {
              video.querySelectorAll("source[data-src]").forEach((source) => {
                source.src = source.dataset.src;
                source.removeAttribute("data-src");
              });
              video.addEventListener("loadeddata", () => {
                video.dataset.loaded = "true";
                resolve();
              }, { once: true });
              video.addEventListener("error", resolve, { once: true });
              video.load();
            };

            const intentEvents = ["pointerdown", "keydown", "touchstart", "wheel"];
            const loadOnce = () => {
              intentEvents.forEach((eventName) => {
                window.removeEventListener(eventName, loadOnce);
              });
              load();
            };

            intentEvents.forEach((eventName) => {
              window.addEventListener(eventName, loadOnce, { once: true, passive: true });
            });
          });
        };

        const playActiveVideo = () => {
          slides.forEach((slide, index) => {
            slide.querySelectorAll("video").forEach((video) => {
              const style = window.getComputedStyle(video);
              const shouldPlay = index === activeIndex && style.display !== "none" && style.visibility !== "hidden";
              if (shouldPlay) {
                video.muted = true;
                video.setAttribute("muted", "");
                video.setAttribute("playsinline", "");
                loadDeferredVideo(video).then(() => {
                  const promise = video.play();
                  if (promise && promise.catch) promise.catch(() => {});
                });
              } else {
                video.pause();
              }
            });
          });
        };

        const showSlide = (index) => {
          if (slides.length === 0) return;
          activeIndex = (index + slides.length) % slides.length;
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle("is-active", isActive);
            slide.setAttribute("aria-hidden", isActive ? "false" : "true");
          });
          dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === activeIndex;
            dot.classList.toggle("is-active", isActive);
            dot.setAttribute("aria-current", isActive ? "true" : "false");
          });
          playActiveVideo();
        };

        const goNext = () => showSlide(activeIndex + 1);
        const start = () => {
          if (!autoplay || slides.length < 2) return;
          intervalId = window.setInterval(() => {
            if (!slideshow.isConnected) {
              window.clearInterval(intervalId);
              return;
            }
            if (!paused) goNext();
          }, interval);
        };

        prev?.addEventListener("click", () => showSlide(activeIndex - 1));
        next?.addEventListener("click", goNext);
        dots.forEach((dot) => {
          dot.addEventListener("click", () => showSlide(Number(dot.dataset.index)));
        });
        if (pauseOnHover) {
          slideshow.addEventListener("mouseenter", () => {
            paused = true;
          });
          slideshow.addEventListener("mouseleave", () => {
            paused = false;
          });
        }
        window.addEventListener("resize", playActiveVideo);

        showSlide(activeIndex);
        start();
      });
    };

    document.addEventListener("DOMContentLoaded", () => initSlideshow());
    document.addEventListener("shopify:section:load", (event) => initSlideshow(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-menu"] && !Shopify.designMode) return;
  try {
    
  console.log('Side Menu section loaded');

  } catch(e) { console.error(e); }
})();
})();
